<template>
  <div style="overflow: hidden; display: block" v-if="message">
    <div class="SL_offerMaterialListView">
      <img :src="message.showImage" @click="goParticulars" />
      <!-- 默认展示 -->
      <div class="SL_offerMaterialList_B">
        <div class="SL_offerMaterialList_B_user">
          <img style="width: 0.24rem; height: 0.24rem; border-radius: 50%" :src="message.avatar ? message.avatar : require('../assets/logo.png')
            " />
          {{ message.createUserName }}
        </div>
        <div class="SL_offerMaterialList_B_uimgList">
          <img style="margin-right: 0.16rem" @click="isSouCang" :src="!isCollect
              ? require('../assets/publick_shoucang.png')
              : require('../assets/publick_shoucangOk.png')
            " />
          <img @click="addShopping" src="../assets/publick_gouwuche.png" />
        </div>
      </div>
      <div class="SL_offerMaterialList_C">
        <span class="LSC_title">{{ message.title }}</span>
        <span class="LSC_time">{{ message.playTime }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { Axios } from "../assets/js/ls_com_axios.js";
const router = useRouter();
const newData = defineProps({
  message: {
    type: Object, //类型字符串
  },
  collectIds: {
    type: Array
  }
});
const collectIds = ref([])
const isCollect = computed(() => {
  return collectIds.value.indexOf(newData.message.id) > -1
})

// 临时解决 未登录的问题
let isUserList = ref(false);
if (localStorage.getItem("userList")) {
  isUserList.value = true;
} else {
  isUserList.value = false;
}
// 跳转详情页
let goParticulars = function () {
  window.open(`/ShadowMaterialVideoParticulars?id=${newData.message.id}`)
  // router.push({
  //   path: "/ShadowMaterialVideoParticulars",
  //   query: {
  //     id: newData.message.id,
  //   },
  // });
};
// 获取详细信息
let setSuCaiList = function () {
  Axios(
    "get",
    "/fodder/info",
    { materialId: newData.message.materialId },
    false,
    function () { }
  );
};
//收藏按钮
let isSouCang = function () {
  console.info("3232", isCollect)
  if (!isCollect.value) {
    // 收藏
    Axios(
      "post",
      "/fodder/collect",
      { materialId: newData.message.id },
      false,
      function (res) {
        collectIds.value.push(newData.message.id);
        ElMessage({
          showClose: true,
          message: "收藏成功",
          type: "success",
        });
      }
    );
  } else {
    //	取消收藏
    Axios(
      "delete",
      "/fodder/collect",
      { materialId: newData.message.id },
      false,
      function (res) {
        console.info('323', collectIds.value.length)
        const index = newData.collectIds.indexOf(newData.message.id);
        collectIds.value.splice(index, 1);
        console.info(collectIds.value.length)
        ElMessage({
          showClose: true,
          message: "已取消收藏",
          type: "warning",
        });
      }
    );
  }
};
//加入购物车
let addShopping = function () {
  if (newData.message.selfPrice == 0) {
    ElMessage({
      message: "免费商品不可加入购物车!",
      type: "warning",
    });
    return false
  }
  Axios(
    "POST",
    "/fodder/car",
    { materialId: newData.message.id },
    false,
    function (res) {
      ElMessage({
        showClose: true,
        message: "已加入购物车",
        type: "success",
      });
    }
  );
};
watch(() => newData.collectIds, () => {
  collectIds.value = newData.collectIds;
}, {
  immediate: true
})
</script>

<style scoped>
.SL_offerMaterialListView {
  overflow: hidden;
  border-radius: 0.1rem;
  /* position: relative; */
  height: 100%;
  /* margin:0.3em 0.4em; */
}

.SL_offerMaterialListView>img {
  width: 100%;
  height: 100%;
  min-height: 1.7rem;
  display: block;
  overflow: hidden;
  border-radius: 0.12rem;
}

.SL_offerMaterialList_A {
  padding: 0.12rem 0.16rem;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.SL_offerMaterialListView:hover .SL_offerMaterialList_B {
  bottom: 0rem;
}

.SL_offerMaterialListView:hover .SL_offerMaterialList_C {
  bottom: -0.6rem;
}

.SL_offerMaterialList_A>span {
  color: #fff;
  font-size: 0.12rem;
}

.SL_offerMaterialList_B {
  padding: 0.12rem 0.08rem;
  position: absolute;
  bottom: 0rem;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  transition: bottom 0.5s;
}

/* .SL_offerMaterialList_B:hover{
	bottom: -0.6rem;
} */

.SL_offerMaterialList_B,
.SL_offerMaterialList_C {
  position: absolute;
  bottom: -0.6rem;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.SL_offerMaterialList_C {
  padding: 0.12rem 0.16rem;
  background: linear-gradient(180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.8) 100%);
  bottom: 0rem;
  border-radius: 0.12rem;
  transition: bottom 0.5s;
}

.SL_offerMaterialList_B_user,
.SL_offerMaterialList_B_imgList {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.SL_offerMaterialList_B_user {
  padding: 0.04rem;
  border-radius: 1rem;
  background: rgba(0, 0, 0, 0.25);
  font-size: 0.12rem;
  color: #fff;
}

.SL_offerMaterialList_B_user>img {
  width: 0.24rem;
}

.SL_offerMaterialList_B_uimgList>img {
  width: 0.32rem;
}

.SL_offerMaterialList_C {
  font-size: 0.12rem;
  color: #ffffff;
}

@media screen and (max-width: 750px) {
  .SL_offerMaterialListView>img {
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    border-radius: 0.12rem;
  }

  .SL_offerMaterialListView {

    margin: 0 0.4em;
  }

  .SL_offerMaterialListView>img {
    min-height: 2em;
  }

  .LSC_title {
    display: none;
  }
}
</style>
